import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag-subscript 461",
  "use": "icon-tag-subscript 461-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-tag-subscript 461\"><path d=\"M821.333333 247.914667L247.914667 821.333333H821.333333V247.914667z\" p-id=\"28751\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol